<template>
  <div class="page-project-task">
    <div class="content">
      <draggable class="list-box" v-model="dataList" draggable=".itemDrag" @change="dragChange($event,item)">
        <div v-for="(item, index) in dataList" :key="index">
          <!-- 可拖动的面板 勿删 -->
          <!-- <div class="itemDrag" v-for="(item, index) in dataList" :key="index"> -->
          <drag-list ref="drag" class="candrag" :list="item.lists" :itemGroup="item" @showProDialog="showDialog" :callFun="addTaskPanel" @refresh="getDataList" />
        </div>
        <div slot="footer">
          <el-card class="panel-add-wrap">
            <p class="panel-add m-assist" @click="addTaskPanel()">
              <svg-icon icon-class="add" class-name="icon-add" />&nbsp;新建任务看板
            </p>
          </el-card>
        </div>
      </draggable>
    </div>

    <cmp-task-detail ref="dialogPro" @getTask="getDataList"></cmp-task-detail>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
// import cmpHeaderSub from '@cmp/header-sub'
// import bus from '@/utils/bus'
import DragList from '@cmp/drag-list'
import cmpTaskDetail from './dialog/dialog-task-detail'
export default {
  components: {
    draggable,
    // cmpHeaderSub,
    DragList,
    cmpTaskDetail
  },
  data() {
    return {
      dataList: []
    }
  },
  methods: {
    dragChange(evt, itemGroup) {
    },
    // 移动
    changeList(params) {
      this.$http.post('/projectTask/moveProjectTask', params).then(res => {
        if (res.success) {
          // this.$message.success('移动成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取列表 名称不可修改
    getDataList() {
      this.$http
        .post('/projectTask/getTaskBoardView', {
          blockId: this.$route.query.projectId
        })
        .then(res => {
          if (res.success) {
            this.dataList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 显示任务详情
    showDialog(item) {
      this.$refs.dialogPro.init(item.taskId)
    },
    // 新建任务看板
    addTaskPanel() {
      // addTaskPanel(title, name) {
      this.$prompt('', '新建任务看板', {
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
        inputPlaceholder: '看板名称',
        // inputPattern: /^[\S]{1,15}$/,
        inputPattern: /^.{1,15}$/,
        inputErrorMessage: '请输入1到15位字符'
        // center: true
      })
        .then(({ value }) => {
          this.$http
            .post('/projectTask/addTaskBoard', {
              taskName: value,
              blockId: this.$route.query.projectId // 项目id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('新建任务看板成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
        })
        .catch(() => { })
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    this.$store.state.user.noScrollY = true

    // bus.$on('globalTaskEvent', () => {
    //   this.getDataList()
    // })
  },
  beforeDestroy() {
    this.$store.state.user.noScrollY = false
  }
}
</script>

<style lang="scss" scoped>
.page-project-task {
  .content {
    position: fixed;
    top: 100px;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 30px;
    padding-bottom: 0;
    overflow-x: auto;
    .list-box {
      display: flex;
    }
    .panel-add-wrap {
      margin-right: 30px;
      width: 330px;
      padding: 20px;
      height: calc(100vh - 162px);
      // height: calc( 100vh - 200px);
      box-sizing: border-box;
      .panel-add {
        padding: 0 20px;
        background: rgba(241, 242, 247, 1);
        border-radius: 4px;
        line-height: 54px;
        cursor: pointer;
      }
    }
  }
}
</style>

